import styled from 'styled-components';

export const CenterCointer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  top: -15px;
`;
CenterCointer.displayName = 'CenterCointer';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 40px;
  margin: 0 8px;
  width: 2px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Container = styled.section`
  font-family: 'Roboto', sans-serif;
  font-size: 36px;
  font-weight: 300;
  margin-top: 70px;
`;
Container.displayName = 'Container';

export const Image = styled.img`
  height: 52px;
  width: 52px;
`;
Image.displayName = 'Image';

export const Logo = styled.img`
  margin-bottom: 8px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  line-height: 56px;
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #f5c327;
  color: #000000;
  display: flex;
  font-size: 52px;
  font-weight: 500;
  justify-content: center;
  text-align: center;
  width: 105px;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  font-size: 30px;
  position: relative;
  top: -2px;
`;
Space.displayName = 'Space';

export const TeamsContainer = styled.div`
  display: flex;
  height: 56px;
`;
TeamsContainer.displayName = 'TeamsContainer';

export const TeamName = styled.div`
  align-items: center;
  background: #000000;
  color: #ffffff;
  display: flex;
  font-size: 52px;
  font-weight: 100;
  line-height: 39px;
  justify-content: center;
`;
TeamName.displayName = 'TeamName';

export const TeamNameAway = styled(TeamName)`
  justify-content: flex-start;
  padding-left: 40px;
`;
TeamNameAway.displayName = 'TeamNameAway';

export const TeamNameHome = styled(TeamName)`
  justify-content: flex-end;
  padding-right: 40px;
`;
TeamNameHome.displayName = 'TeamNameHome';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  box-sizing: content-box;
  display: flex;
  height: 34px;
  justify-content: center;
  margin-top: 8px;
  width: 105px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #000000;
  font-weight: 400;
  letter-spacing: 0.03em;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';
